
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeEndPoint as ObiPipeEndPointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-end-point.js';
 
 
 

 
 export const ObiPipeEndPoint = createComponent({
   react: React,
   tagName: 'obi-pipe-end-point',
   elementClass: ObiPipeEndPointElement,
   events: {
     
   }
  });
 
 